// dependencies
import React from "react";

// components
import PageTitle from "../../components/PageTitle";
import Spinner from "../../components/Spinner/ComponentLoader";

const ExtendSessionPage = () => (
	<>
		<PageTitle title="Extend Session" />
		<Spinner>Please wait while we log you in...</Spinner>
	</>
);

export default ExtendSessionPage;
